module.exports = __webpack_public_path__ + "static/img/jianting2.7833608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/jianting2.png
// module id = 8u/z
// module chunks = 24